import { render, staticRenderFns } from "./auditPrescription.vue?vue&type=template&id=99099aaa&scoped=true&"
import script from "./auditPrescription.vue?vue&type=script&lang=js&"
export * from "./auditPrescription.vue?vue&type=script&lang=js&"
import style0 from "./auditPrescription.vue?vue&type=style&index=0&id=99099aaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99099aaa",
  null
  
)

export default component.exports